import React, { useState } from "react";
import CurrentEmployee from "./Component/CurrentEmployee";
import PastEmployeePage from "./Component/PastEmployeePage";
import { COLOR } from "../../../Config/Color";
import MainLayout from "../../../../layouts/MainLayout";
import "../../AdminPage/AdminNewPage/Style/NewAttendancePage.css"

const EmployeeListPage = () => {
  const [activeTab, setActiveTab] = useState("Current Employees");

  const tabs = ["Current Employees", "Past Employees"];
  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <div className="newattendance-container">
            <h1 className="my-2 text-start fs-24 text-dark">
              Employee Sheet
            </h1>

            <div className="flex items-center  border-b border-gray-300 px-10 pt-2 bg-white rounded-lg shadow-sm">
              {/* Tabs */}
              <div className="d-flex align-items-center gap-3 py-2">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={` font-medium pb-3 ${activeTab === tab
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-[#78829D]" // Custom color for inactive tab
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ marginTop: "20px", width: "100%" }}>
              {activeTab === "Current Employees" && <CurrentEmployee />}
              {activeTab === "Past Employees" && <PastEmployeePage />}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EmployeeListPage;
